import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { parse } from 'qs';
import { Header, PageLoading, RecordStatus, ErrorDisplay } from '../components';
import { getStatusOfSentRecordById, getStatusOfSentPatientRecordById } from '../actions/records';
import { openModal } from '../actions/modal';
import SentRecordStatusRedesign from '../components/sent/SentRecordStatusRedesign';
import { SENT_STATUS_REDESIGN_FEATURE, verifyFeatureAccess } from '../global/featureFlags';
import '../components/main.scss';

const FLAG_TIMEOUT_MS = 3000;

const parseOptions = {
  ignoreQueryPrefix: true,
};

class SentRecordStatus extends Component {
  constructor(props) {
    super(props);
    this.recordId = props.match.params.record_id;
    // null until the flag resolves, so neither layout flashes before the other.
    this.state = { redesign: null };
  }

  componentDidMount() {
    this.mounted = true;
    // A flags request that never settles must not hold the page on a spinner: after
    // FLAG_TIMEOUT_MS fall back to the legacy layout, which is what flag-off renders.
    Promise.race([
      verifyFeatureAccess(SENT_STATUS_REDESIGN_FEATURE),
      new Promise((resolve) => { this.flagTimer = setTimeout(() => resolve(false), FLAG_TIMEOUT_MS); }),
    ])
      .catch(() => false)
      .then((redesign) => {
        clearTimeout(this.flagTimer);
        if (this.mounted) this.setState({ redesign: redesign === true });
      });

    const sendToken = this.props.match.params.id;
    const { location } = this.props;
    const params = parse(location.search, parseOptions);

    if (params.patient === 'true') {
      this.props.getStatusOfSentPatientRecordById(this.recordId, sendToken);
    } else {
      this.props.getStatusOfSentRecordById(this.recordId, sendToken);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    clearTimeout(this.flagTimer);
  }

  isPatient() {
    const { location } = this.props;
    const params = parse(location.search, parseOptions);

    return params.patient === 'true';
  }

  render() {
    const { data, openModal } = this.props;
    const { redesign } = this.state;
    const StatusComponent = redesign ? SentRecordStatusRedesign : RecordStatus;
    return (
      <div>
        <Helmet>
          <title>Record Status - Medsender</title>
        </Helmet>
        <div
          className={`med-container ${this.props.docked ? 'true-dock' : 'false-dock'}`}
        >
          <Header
            main="Sent record status"
            subtext="All the details are below"
            locationPath={[
              { icon: 'home', text: 'Home', link: '/app' },
              { icon: 'inbox', text: 'Sent', link: '/app/sent' },
            ]}
          />
          {/* A failed load has nothing left to wait for, flag or not. */}
          { (this.props.loading || (redesign === null && !this.props.errorMessage)) && <PageLoading /> }
          { data && !this.props.loading && redesign !== null &&
            <StatusComponent
              data={data}
              openModal={openModal}
              fileToken={this.recordId}
              patient={this.isPatient()}
            />
          }
          { this.props.errorMessage && !this.props.loading ?
            <p style={{ textAlign: 'center', marginTop: '60px' }}>
              <ErrorDisplay message={this.props.errorMessage} />
            </p> : null
          }
        </div>
      </div>
    );
  }
}

SentRecordStatus.defaultProps = {
};

SentRecordStatus.propTypes = {
  getStatusOfSentRecordById: PropTypes.func.isRequired,
  getStatusOfSentPatientRecordById: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
};

export default connect(state => ({
  loading: state.records.isLoading,
  data: state.records.currentRecordStatus,
  errorMessage: state.records.errorMessage,
}), {
  getStatusOfSentRecordById,
  getStatusOfSentPatientRecordById,
  openModal,
})(SentRecordStatus);

export {
  SentRecordStatus,
};
